import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';

export function generateEvElectricLink(): string {
  return `${generateSearchLinkFilter({
    filters: { fuelTypes: ['Electric'] }
  })}&p_bnr=ev`;
}
